<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
const PASS_EXAM_MAPPER = {pass: 'Đã trúng tuyển', fail: 'Không trúng tuyển', reserve: 'Dự khuyết'}
export default {
  computed: {...mapGetters({user: 'auth/user', filterParams: 'cv/filterParams'})},
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    renderCvStatus(val) {
      if (val === 'submitted') return 'Đã nộp'
      if (val === 'created') return 'Vừa tạo'
      if (val === 'disabled') return 'Đang tắt'
      return 'Đang khai'
    },
    renderGroupExpectationG10(cv) {
      if (cv.type === 'Khối 10') {
        const NV1 = get(cv, 'ltvExamResult.groupExpectation1', '')
        const NV2 = get(cv, 'ltvExamResult.groupExpectation2', '')
        return `- Nguyện vọng 1: ${NV1}\n- Nguyện vọng 2: ${NV2}`
      }
      return ''
    },
    renderTransDetail(cv) {
      const transCode = get(cv, 'activeCodeTransaction.transactionCode', '')
      const transId = get(cv, 'activeCodeTransaction.transactionId', '')

      return {transCode, transId}
    },
    renderPassExamText(text = '') {
      return get(PASS_EXAM_MAPPER, text, '')
    },
    async onExport() {
      this.$loading.active = true
      const cvs = await this.fetchCVsIndependent({...this.filterParams, _start: 0, _limit: -1, type: 'Khối 10'})
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => {
          return {
            'Mã hồ sơ': cv.code,
            'Trạng thái': this.renderCvStatus(cv.status),
            'Tạo lúc': moment(cv.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            'Cập nhật lúc': moment(cv.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
            'Tài khoản kích hoạt': cv.parentUsername,
            'Cơ sở': cv.department === 'unset' ? 'Chưa có thông tin' : cv.department,
            //
            'Họ tên học sinh': cv.name,
            'Ngày sinh': cv.dob ? moment(cv.dob, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
            'Giới tính': cv.gender === 'female' ? 'Nữ' : 'Nam',
            'Mã học sinh (do Bộ GD&ĐT cấp)': cv.studentId,
            'Trường từng học': cv.school,
            //
            'Họ tên NGH': get(cv, 'parentName', ''),
            'Mối quan hệ với HS': get(cv, 'parentRelation', ''),
            'SDT NGH': get(cv, 'parentPhone', ''),
            'CCCD NGH': get(cv, 'parentResidentID', ''),
            'Email NGH': get(cv, 'parentEmail', ''),
            //
            'Thành tích nổi bật': get(cv, 'studyRecord.achievements', ''),
            'Diện tuyển thẳng (Khối 10)': get(cv, 'studyRecord.recuitingStraightType', ''),
            'Nguyện vọng Ban (Khối 10)': this.renderGroupExpectationG10(cv),
            'Điểm thi Toán': get(cv, 'ltvExamResult.examMath') || get(cv, 'ltvExamResult.examMathMark'),
            'Điểm thi Văn': get(cv, 'ltvExamResult.examLiterature'),
            'Điểm thi Anh': get(cv, 'ltvExamResult.examEnglish'),
            //
            'Điểm cộng': get(cv, 'ltvExamResult.priorityMark', ''),
            'Tổng điểm': get(cv, 'ltvExamResult.examTotalMark', ''),
            'Kết quả trúng tuyển': this.renderPassExamText(get(cv, 'ltvExamResult.passExamText'), ''),
          }
        }),
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ket-qua-thi-k10.xlsx')
      this.$loading.active = false
    },
  },
}
</script>
